import * as React from 'react';
const ModalCoverCore = (props) => {
    const BEM = () => {
        const classArray = ['modal__cover'];
        if (props.fillImage) {
            classArray.push('modal__cover--fill');
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    const CSS = () => {
        let styleEntities = {};
        if (props.minHeight) {
            styleEntities = {
                minHeight: `${props.minHeight}px`,
            };
        }
        styleEntities.backgroundColor = props.backgroundColor;
        return styleEntities;
    };
    const iconCSS = () => {
        let styleEntities = {};
        if (props.iconMaxWidth) {
            styleEntities = {
                maxWidth: `${props.iconMaxWidth}px`,
            };
        }
        styleEntities.color = props.iconColor;
        return styleEntities;
    };
    const getIcon = (icon) => {
        const { Icon } = props.components;
        return React.createElement(Icon, Object.assign({}, icon, { className: "modal__cover-icon", style: iconCSS() }));
    };
    const getImage = (image) => {
        const { Image, ObjectFit } = props.components;
        if (props.fillImage) {
            return (React.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center" },
                React.createElement(Image, Object.assign({ className: "modal__cover-image" }, image))));
        }
        return React.createElement(Image, Object.assign({ className: "modal__cover-image" }, image));
    };
    return (React.createElement("div", { className: BEM(), style: CSS() },
        props.icon && getIcon(props.icon),
        props.image && getImage(props.image)));
};
export default ModalCoverCore;
